<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h6 primary white--text"> Selecione as turmas </v-card-title>
        <v-select
          class="px-3 my-5"
          :items="turmasList"
          item-text="descricao"
          item-value="id"
          multiple
          return-object
          label="Selecione as turmas"
          v-model="turmasSelecionadas"
          @change="validarSelecaoTurmas"
        ></v-select>

        <div v-if="turmasSelecionadas.length > 0" class="px-3 mb-3">
          <v-chip small color="primary" class="mb-2">
            {{ turmasSelecionadas.length }} turma{{
              turmasSelecionadas.length > 1 ? "s" : ""
            }}
            selecionada{{ turmasSelecionadas.length > 1 ? "s" : "" }}
            / 6 máximo
          </v-chip>
          <div class="text-caption grey--text mb-2">
            Recomendado até 6 turmas para melhor desempenho no download
          </div>

          <v-alert v-if="turmasSelecionadas.length >= 6" type="info" dense outlined class="mb-2">
            <v-icon small class="mr-2">mdi-information</v-icon>
            Limite de 6 turmas atingido. Para garantir um bom desempenho no download dos boletins,
            selecione no máximo 6 turmas por vez.
          </v-alert>

          <v-alert
            v-else-if="turmasSelecionadas.length > 4"
            type="warning"
            dense
            outlined
            class="mb-2"
          >
            <v-icon small class="mr-2">mdi-clock-alert</v-icon>
            Atenção: Para garantir um bom desempenho no download, recomendamos selecionar até 6
            turmas. Selecionar mais turmas pode aumentar o tempo de processamento.
          </v-alert>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="$emit('dialogChange', false)"> Fechar </v-btn>
          <v-btn
            color="primary"
            text
            @click="gerarRelatorio"
            :disabled="turmasSelecionadas.length === 0 || turmasSelecionadas.length > 6"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    franquia_id: {
      type: Number,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      turmasList: [],
      turmasSelecionadas: [],
      dialogConfirmacao: false,
    };
  },
  watch: {
    dialog: {
      async handler(newVal) {
        if (newVal) {
          await this.listarTurmasFranquiaSelect(this.franquia_id);
        }
      },
    },
    turmasSelecionadas: {
      handler(newVal) {
        if (newVal && newVal.length > 6) {
          this.$nextTick(() => {
            this.turmasSelecionadas = newVal.slice(0, 6);
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    validarSelecaoTurmas(selecionadas) {
      if (selecionadas && selecionadas.length > 6) {
        this.turmasSelecionadas = selecionadas.slice(0, 6);
        this.$toast.danger(
          "Limite máximo alcançado. Para manter o bom desempenho no download dos boletins, escolha até 6 turmas por vez."
        );
      }
    },
    async listarTurmasFranquiaSelect(franquia) {
      this.carregandoTurmas = true;
      try {
        const response = await this.$services.turmasService.listarTurmasFundamentalFranquia({
          franquia_id: franquia,
        });
        this.turmasList = response;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoTurmas = false;
      }
    },
    async confirmarSelecao() {
      if (this.turmasSelecionadas.length === 0) {
        this.$toast.danger("Selecione pelo menos uma turma.");
        return;
      }

      if (this.turmasSelecionadas.length > 6) {
        this.$toast.danger(
          "Limite máximo alcançado. Para manter o bom desempenho no download dos boletins, escolha até 6 turmas por vez."
        );
        return;
      }

      if (this.turmasSelecionadas.length > 5) {
        this.dialogConfirmacao = true;
      } else {
        this.gerarRelatorio();
      }
    },
    async gerarRelatorio() {
      this.dialogConfirmacao = false;
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.relatoriosService.boletinsFranquia(
          this.franquia_id,
          this.turmasSelecionadas.map((turma) => turma.id)
        );
        this.turmasSelecionadas = [];
        this.$emit("dialogChange", false);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
